import { getWaitSeconds } from '../conditionWait';

/**
 * Condition entry for storage / UI: taskId, branch, and optional waitSeconds.
 */
export function toConditionEntry(cond) {
  if (!cond) return { taskId: '', branch: null };
  const taskId = typeof cond === 'string' ? cond : (cond.taskId || '');
  const branch = typeof cond === 'string' ? null : (cond.branch || null);
  const waitSeconds = typeof cond === 'string'
    ? null
    : getWaitSeconds({
        waitSeconds: cond.waitSeconds,
        waitMinutes: cond.waitMinutes,
      });
  return waitSeconds
    ? { taskId, branch, waitSeconds }
    : { taskId, branch };
}

/**
 * Data structure (v2 - block-based):
 *
 * Storage format:
 * {
 *   version: 2,
 *   blocks: [
 *     {
 *       conditions: [{ taskId: 'taskId1', branch: null }, { taskId: 'taskId2', branch: 'option-yes' }],
 *       innerOperator: 'AND',
 *       outerOperator: null
 *     },
 *     {
 *       conditions: [{ taskId: 'taskId3', branch: null }],
 *       innerOperator: 'AND',
 *       outerOperator: 'OR'
 *     }
 *   ]
 * }
 *
 * This represents: (task1 AND task2→YES) OR (task3)
 *
 * Legacy v1 storage format (flat unlockConditions array):
 * [
 *   { taskId: 'taskId1', operator: null },
 *   { taskId: 'taskId2', branch: 'option-yes', operator: 'AND' },
 *   { taskId: 'taskId3', operator: 'OR' },
 * ]
 *
 * Internal UI format (blocks):
 * blocks = [
 *   { conditions: [{ taskId: 'taskId1', branch: null }, ...], innerOperator: 'AND' },
 *   { conditions: [{ taskId: 'taskId3', branch: null }], innerOperator: 'AND' },
 * ]
 * outerOperators = [null, 'OR']
 */

export function isV2Format(unlockConditions) {
  return unlockConditions && typeof unlockConditions === 'object' && !Array.isArray(unlockConditions) && unlockConditions.version === 2;
}

export function isV1Format(unlockConditions) {
  return Array.isArray(unlockConditions);
}

export function getDependencyTaskId(dep) {
  if (typeof dep === 'string') return dep;
  return dep?.taskId || null;
}

export function getDependencyBranch(dep) {
  if (typeof dep === 'string') return null;
  return dep?.branch || null;
}

export function getTaskEntryId(taskEntry) {
  return typeof taskEntry === 'string' ? taskEntry : taskEntry?.taskId;
}

export function getTaskEntryBranch(taskEntry) {
  return typeof taskEntry === 'string' ? null : taskEntry?.branch;
}

export function hasValidTaskId(taskEntry) {
  const taskId = getTaskEntryId(taskEntry);
  return !!taskId;
}

export function createEmptyTaskEntry() {
  return { taskId: '', branch: null };
}

export function createEmptyBlock() {
  return { conditions: [createEmptyTaskEntry()], innerOperator: 'AND' };
}

/**
 * @deprecated Use createEmptyBlock instead
 */
export function createEmptyOption() {
  return { tasks: [createEmptyTaskEntry()] };
}
